import angular from 'angular';

module.exports = angular.module('common.directives.currency', [
  require('../filters/currency')
])
.directive('type', function typeCurrency(currencyFilter, formattedCursorPosition) {
  var currencyTypeReg = /^currency(:(\d))?$/;

  function dollarFilter(value, decimals, hasDecimals) {
    if (!value && value !== 0) return '';
    if (value === '-') return '$-';

    // Limit to max of 12 numbers
    var numbers = value.toString().trim().replace(/[^\d\.\-]/g, '').slice(0, 12);
    var formatted = currencyFilter(numbers * 100, decimals);

    // We need to be able to type the decimals. If we leave it up to the filter and decimal count
    // We have weird things happen
    if (hasDecimals && formatted.indexOf('.') === -1) {
      return formatted + '.';
    } else {
      return formatted;
    }
  }

  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      var match = attrs.type.match(currencyTypeReg);

      if (!match || !ngModel) return;

      var maxDecimals = parseInt((match[2] || '').toString(), 10) || 0;

      // String Dollars -> Number Cents
      ngModel.$parsers.push(function(oldValue) {
        if (!oldValue) return null;

        var numbers = oldValue.toString().trim().replace(/[^\d\.\-]/g, ''),
            decimalIndex = numbers.indexOf('.'),
            decimals = 0, currentDecimals, hasDecimals, numericValue;

        if (decimalIndex > -1) {
          hasDecimals = maxDecimals > 0;
          currentDecimals = numbers.length - 1 - decimalIndex;

          if (currentDecimals > maxDecimals) {
            decimals = maxDecimals;
          } else {
            decimals = currentDecimals;
          }
        }

        let newValue = dollarFilter(numbers, decimals, hasDecimals);

        let oldCursorPosition = element[0].selectionStart;
        let newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);
        element.val(newValue);
        ngModel.$setViewValue(newValue);
        ngModel.$commitViewValue(newValue);
        element[0].setSelectionRange(newCursorPosition, newCursorPosition);

        numericValue = Math.round(parseFloat(numbers) * 100);
        if (isNaN(numericValue)) numericValue = null;
        return numericValue;
      });

      // Number Cents -> String Dollars
      ngModel.$formatters.push(function(value) {
        if (!value && value !== 0) return;
        return dollarFilter(value / 100, maxDecimals);
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/currency.js
 **/